<template>
  <el-button class="sk-p2-button" v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  name: "Phase2ActionButton",
  inheritAttrs: false,
};
</script>
